<template>
  <div class="layout">
    <Layout>
      <Sider
        ref="side1"
        hide-trigger
        collapsible
        :collapsed-width="92"
        v-model="isCollapsed"
        style="background: #fff; box-shadow: 2px 0px 6px 0px #e7e7fc"
      >
        <div class="logobox">
          <router-link to="/" v-if="!isCollapsed">
            <img :src="logoURL" alt="DANONE" title="DANONE" class="logo" />
          </router-link>
          <Icon
            type="md-reorder"
            size="20"
            color="#0D6EFD"
            @click.native="collapsedSider"
            :class="isCollapsed ? 'logoBoxI' : ''"
          />
        </div>
        <!-- 在data中新增页面，按格式添加 -->
        <Menu
          accordion
          theme="light"
          :style="{ width: 'auto' }"
          :class="isCollapsed ? 'collapsed-menu' : 'menu-item'"
        >
          <MenuItem to="/homepage" name="homepage" key="homepage">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-yinhang"></use>
            </svg>
            <span class="menuTitle">首页</span>
          </MenuItem>
          <Submenu v-for="(item, index) in menuMap" :name="index" :key="index">
            <template slot="title">
              <svg class="icon" aria-hidden="true" v-if="item.fonticon">
                <use :xlink:href="item.fonticon"></use>
              </svg>
              <Icon :type="item.icon" v-else />
              <span class="menuTitle">{{ item.title }}</span>
            </template>
            <template v-if="item.children">
              <MenuItem
                v-for="(each, i) in item.children"
                :name="index + '-' + i"
                :key="index + '-' + i"
                :to="each.path"
                ><span class="menuTitle">{{ each.title }}</span>
              </MenuItem>
            </template>
          </Submenu>
        </Menu>
      </Sider>
      <Layout>
        <Header
          :style="{ background: '#fff', boxShadow: '0px 1px 4px 0px #EBEBFD' }"
        >
          <Row type="flex" justify="space-between" class="code-row-bg">
            <Col span="20">
              <Breadcrumb>
                <BreadcrumbItem
                  v-for="(item, index) in list"
                  :key="index"
                  :to="item.path"
                  >{{ item.name }}
                </BreadcrumbItem>
              </Breadcrumb>
            </Col>
            <Col class="headerCol">
              <img :src="autorUrl" alt="autor" title="autor" class="autor" />
              <Dropdown trigger="click" style="margin-left: 6px">
                <div class="dropcontent">
                  <div class="dropleft">
                    <div class="droptitle">{{ name }}</div>
                    <div>{{ roleName }}</div>
                  </div>
                  <Icon type="ios-arrow-down" />
                </div>
                <Dropdown-menu slot="list">
                  <Dropdown-item
                    @click.native="formModel = true"
                    name="reset"
                    key="reset"
                  >
                    修改密码
                  </Dropdown-item>
                  <Dropdown-item
                    @click.native="loginOut"
                    name="loginOut"
                    key="loginOut"
                  >
                    退出系统
                  </Dropdown-item>
                </Dropdown-menu>
              </Dropdown>
            </Col>
          </Row>
        </Header>
        <Content class="content">
          <div v-if="list" class="topBar">
            <div class="topBarTitle">{{ list[list.length - 1].name }}</div>
            <Button @click="goback">返回</Button>
          </div>
          <div
            :class="ishomepage ? 'homecBox' : 'contentBox'"
            :style="{
              minHeight: list ? 'calc( 100vh - 184px)' : 'calc( 100vh - 112px)',
            }"
          >
            <!-- <p slot="title">title</p> -->
            <router-view></router-view>
          </div>
        </Content>
        <!-- <Footer>Footer</Footer> -->
      </Layout>
    </Layout>
    <!-- 修改密码 -->
    <Modal
      v-model="formModel"
      title="修改密码"
      :loading="formModalLoading"
      :mask-closable="false"
      @on-ok="submit"
      @on-cancel="cancel"
    >
      <Form
        ref="formValidate"
        :model="formItem"
        :rules="ruleValidate"
        :label-width="100"
      >
        <FormItem label="原密码" prop="pwd">
          <Input
            v-model="formItem.pwd"
            :type="eye ? 'text' : 'password'"
            placeholder="请输入原密码"
          >
            <Icon
              slot="suffix"
              :type="eye ? 'ios-eye' : 'ios-eye-off'"
              @click="eye = !eye"
            />
          </Input>
        </FormItem>
        <FormItem label="新密码" prop="newPwd">
          <Input
            v-model="formItem.newPwd"
            :type="eye1 ? 'text' : 'password'"
            placeholder="请输入新密码"
          >
            <Icon
              slot="suffix"
              :type="eye1 ? 'ios-eye' : 'ios-eye-off'"
              @click="eye1 = !eye1"
            />
          </Input>
        </FormItem>
        <FormItem label="确认新密码" prop="newPwd2">
          <Input
            v-model="formItem.newPwd2"
            :type="eye2 ? 'text' : 'password'"
            placeholder="请确认新密码"
          >
            <Icon
              slot="suffix"
              :type="eye2 ? 'ios-eye' : 'ios-eye-off'"
              @click="eye2 = !eye2"
            />
          </Input>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
<script>
// 左侧目录
const menuTree = [
  {
    title: "基础配置",
    icon: "ios-settings",
    fonticon: "#icon-fapiao",
    children: [
      {
        title: "部门管理",
        path: "/depaManagement",
      },
      {
        title: "角色管理",
        path: "/roleManagement",
      },
      {
        title: "用户管理",
        path: "/userManagement",
      },
      {
        title: "菜单管理",
        path: "/menuManagement",
      },
    ],
  },
  {
    title: "商品信息",
    icon: "md-cube",
    fonticon: "#icon-pingtai",
    children: [
      {
        title: "品牌信息",
        path: "/brandInfo",
      },
      {
        title: "分类信息",
        path: "/classInfo",
      },
      {
        title: "属性信息",
        path: "/attriInfo",
      },
      {
        title: "SPU信息",
        path: "/spuInfo",
      },
      {
        title: "SKU信息",
        path: "/skuInfo",
      },
      {
        title: "SKU平台信息",
        path: "/stageInfo",
      },
      {
        title: "SKU资金商管理",
        path: "/skuSpManage",
      },
      {
        title: "资金商SKU查看",
        path: "/spSkuInfo",
      },
      {
        title: "商品标签",
        path: "/labelInfo",
      },
      {
        title: "价格管理",
        path: "/priceInfo",
      },
    ],
  },
  {
    title: "仓库管理",
    icon: "md-home",
    fonticon: "#icon-cangchucangku",
    children: [
      {
        title: "仓库列表",
        path: "/wareList",
      },
      {
        title: "仓库拆分规则",
        path: "/splitList",
      },
      {
        title: "仓库盘点",
        path: "/inventory",
      },
      {
        title: "采购单管理",
        path: "/orderList",
      },
      {
        title: "渠道管理",
        path: "/warehouse/entry",
      },
    ],
  },
  {
    title: "财务管理",
    icon: "md-card",
    children: [
      {
        title: "返利导入",
        path: "/rebateImport",
      },
      {
        title: "返利收入",
        path: "/rebateIncome",
      },
      {
        title: "返利支出",
        path: "/rebateExpend",
      },
      {
        title: "钱包导入",
        path: "/walletImport",
      },
      {
        title: "钱包收入",
        path: "/walletIncome",
      },
      {
        title: "钱包支出",
        path: "/walletExpend",
      },
    ],
  },
  {
    title: "通知消息",
    icon: "md-notifications",
    children: [
      {
        title: "消息列表",
        path: "/messageList",
      },
    ],
  },
  {
    title: "渠道管理",
    icon: "md-options",
    fonticon: "#icon-quanlingyuguimo",
    children: [
      {
        title: "门店列表",
        path: "/store/manage",
      },
      {
        title: "客户集团管理",
        path: "/groupInfo",
      },
    ],
  },
  {
    title: "配额管理",
    icon: "md-pie",
    children: [
      {
        title: "省份配额",
        path: "/allocProvince",
      },
      {
        title: "门店配额",
        path: "/allocRetailer",
      },
      {
        title: "客户集团配额",
        path: "/allocRetailerGroup",
      },
      {
        title: "仓库配额",
        path: "/allocShipTo",
      },
    ],
  },
  {
    title: "资金商/服务商",
    icon: "logo-usd",
    fonticon: "#icon-zhengfu",
    children: [
      {
        title: "资金商管理",
        path: "/merchant/list",
      },
      {
        title: "服务商管理",
        path: "/serviceInfo",
      },
      {
        title: "门店挂靠关系",
        path: "/merchant/relation",
      },
    ],
  },
  {
    title: "优惠券",
    icon: "md-cash",
    fonticon: "#icon-piaoju",
    children: [
      {
        title: "优惠券模板",
        path: "/coupon/template/list",
      },
      {
        title: "优惠券发放申请",
        path: "/coupon/apply/list",
      },
      {
        title: "优惠券列表",
        path: "/coupon/use/list",
      },
    ],
  },
  {
    title: "订单管理",
    icon: "ios-podium",
    children: [
      {
        title: "分销订单",
        path: "/order/list",
      },
    ],
  },
  {
    title: "门店任务",
    icon: "md-list-box",
    children: [
      {
        title: "门店陈列",
        path: "/shopTask/shopDisplay",
      },
      {
        title: "门店Pos",
        path: "/shopTask/shopPos",
      },
    ],
  },
  {
    title: "任务管理",
    icon: "md-notifications",
    children: [
      {
        title: "任务列表",
        path: "/taskManage",
      },
    ],
  },
];

const icons = {
  "0001": "ios-settings",
  "0006": "md-cube",
  "0017": "md-home",
  "0022": "md-card",
  "0029": "md-notifications",
  "0031": "md-options",
  "0034": "logo-usd",
  "0038": "md-cash",
  "0043": "ios-podium",
  "0045": "md-list-box",
};
import { encryptAES } from '@/utils/encrypt'

export default {
  name: "layout",
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入新密码"));
      } else if (value !== this.formItem.newPwd) {
        callback(new Error("两次输入新密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      logoURL: require("@/assets/DANONE_LOGO.png"),
      autorUrl: require("@/assets/autor.png"),
      menuTree,
      menuMap: {},
      name: "",
      roleName: "",
      isCollapsed: false,
      formModel: false,
      formModalLoading: true,
      formItem: {
        pwd: "",
        newPwd: "",
        newPwd2: "",
      },
      eye: false,
      eye1: false,
      eye2: false,
      ruleValidate: {
        pwd: [{ required: true, message: "请输入原密码", trigger: "blur" }],
        newPwd: [{ required: true, message: "请输入新密码", trigger: "blur" }],
        newPwd2: [
          { required: true, validator: validatePass2, trigger: "blur" },
        ],
      },
    };
  },
  watch: {
    $route() {
      // 监听路由变化
      this.list = [];
      this.list = this.$route.meta.menu;
      this.ishomepage = false;
      this.ishomepage = this.$route.name === "homepage" ? true : false;
    },
  },
  created() {
    // 获取登录名及id
    this.name = window.sessionStorage.getItem("name");
    this.roleName = window.sessionStorage.getItem("roleName");
    this.list = this.$route.meta.menu;
    this.ishomepage = this.$route.name === "homepage" ? true : false;
    // 获取菜单
    const menuMap = {};
    let menus = window.sessionStorage.getItem("menus");
    menus = JSON.parse(decodeURIComponent(menus));
    menus = menus.filter((item) => item.mType == "0");
    menus.forEach((menu) => {
      // parent
      if (!menu.parent) {
        menuMap[menu.code] = {
          title: menu.label,
          icon: menu.icon,
          children: [],
        };
      }

      if (menu.parent) {
        if (menuMap[menu.parent]) {
          menuMap[menu.parent].children.push({
            title: menu.label,
            path: menu.url,
          });
        }
      }
    });
    this.$set(this, "menuMap", menuMap);
  },
  methods: {
    //点击按钮收缩展开目录
    collapsedSider() {
      this.$refs.side1.toggleCollapse();
    },
    //点击返回
    goback() {
      this.$router.push({
        path: this.list[this.list.length - 2].path,
      });
    },
    // 修改密码
    submit() {
      this.formModalLoading = false;
      this.$nextTick(() => {
        this.formModalLoading = true;
      });
      let data = { ...this.formItem };
      this.$refs["formValidate"].validate((valid) => {
        if (valid) {
          delete data.newPwd2;
          data.pwd = encryptAES(data.pwd);
          data.newPwd = encryptAES(data.newPwd);
          this.$api["userUpdatePwdCurr"](data).then((res) => {
            if (res.code == "200") {
              this.$Message.success("修改成功");
              this.cancel();
            }
          });
        }
      });
    },
    cancel() {
      Object.keys(this.formItem).forEach((key) => {
        this.formItem[key] = "";
      });
      this.$refs["formValidate"].resetFields();
      this.formModel = false;
    },
    // 退出登录
    loginOut() {
      let that = this;
      let data = {
        token: window.sessionStorage.getItem("token"),
      };
      this.$Modal.confirm({
        title: "提示",
        content: `确认退出登录`,
        okText: "确定",
        cancelText: "取消",
        onOk: async () => {
          that.$api["userExit"](data).then((res) => {
            if (res.code == "200") {
              that.$Message.success("退出成功");
              window.sessionStorage.clear();
              that.$router.replace("/login");
            }
          });
        },
      });
    },
  },
};
</script>
<style scoped>
.logobox {
  height: 64px;
  width: 100%;
  border-bottom: 1px solid #e4e4e4;
  box-shadow: 2px 0px 6px 0px #e7e7fc;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 15px;
}
.logobox i {
  cursor: pointer;
}
.logoBoxI {
  margin-left: 25px;
  transform: rotate(-90deg);
}
.logo {
  height: 64px;
  vertical-align: top;
}

.ivu-layout-header {
  padding: 0 20px;
}
.content {
  padding: 24px;
  background: #f0f2f5;
}
.autor {
  height: 42px;
  width: 42px;
}
.headerCol {
  display: flex;
  align-items: center;
  height: 64px;
}
.headerCol .dropcontent {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.headerCol .dropcontent .dropleft {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 64px;
  margin-right: 20px;
}
.headerCol .dropcontent .dropleft div {
  height: 22px;
  line-height: 22px;
  text-align: center;
  font-size: 13px;
  font-weight: 400;
  color: #a9a8a8;
}
.headerCol .dropcontent .dropleft div.droptitle {
  font-size: 15px;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.65);
}
.ivu-menu-vertical.ivu-menu-light:after {
  width: 0;
  box-shadow: 2px 0px 6px 0px #e7e7fc;
}
.topBar {
  height: 70px;
  background: #fff;
  margin: -23px -24px 24px -24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  border-bottom: 1px solid #e9e9e9;
}
.topBarTitle {
  font-size: 20px;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.85);
  line-height: 28px;
}
.homecBox {
  background: #fff;
  background: linear-gradient(315deg, #dcf8f9 0%, #ffffff 100%);
  box-shadow: 0px 0px 6px 0px #ebebfd;
  border-radius: 10px;
}
.contentBox {
  background: #fff;
  padding: 20px;
  box-shadow: 0px 0px 6px 0px #e2e2f8;
  border-radius: 8px;
}
.ivu-menu-light.ivu-menu-vertical
  .ivu-menu-item-active:not(.ivu-menu-submenu)
  svg,
.ivu-menu-vertical .ivu-menu-item:hover,
.ivu-menu-vertical .ivu-menu-submenu-title:hover svg {
  fill: #2d8cf0;
}

.menu-item .icon {
  width: 14px;
  height: 14px;
  margin-bottom: -1px;
  margin-right: 8px;
}
.collapsed-menu span.menuTitle {
  display: none;
}
.collapsed-menu i {
  font-size: 20px;
}
.collapsed-menu .icon {
  width: 20px;
  height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/layout.vue